import { gql } from '@apollo/client';

// Persists the partnership editors (description, workforce denominator, volunteering
// opportunities, employment categories).
//
// Volunteer roles are reconciled by `id` — send the existing id back for a row you're
// editing, or omit it for a new one. Dropping the id would recreate the row and discard
// the interest people have expressed in it. Employment categories are still replace-all
// (nothing references them).
export const UPDATE_PARTNERSHIP = gql`
mutation UpdatePartnership(
  $supporterId: Int!
  $description: String
  $workforceTotal: Int
  $volunteerRoles: [VolunteerRoleInput!]
  $employmentCategories: [EmploymentCategoryInput!]
) {
  updatePartnership(
    supporterId: $supporterId
    description: $description
    workforceTotal: $workforceTotal
    volunteerRoles: $volunteerRoles
    employmentCategories: $employmentCategories
  ) {
    id
  }
}`;
